import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export function SlotPicker({ date, nbClim, value, onChange, testid = "slot-picker" }) {
  const { data, isLoading } = useQuery({
    queryKey: ["availability", date, nbClim],
    queryFn: async () => (await api.get(`/availability?date=${date}&nb_clim=${nbClim}`)).data,
    enabled: !!date,
  });

  if (!date) return <p className="text-sm text-slate-400">Choisissez une date pour voir les créneaux.</p>;
  if (isLoading) return <div className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />Chargement des créneaux…</div>;

  const slots = data?.slots || [];
  return (
    <div data-testid={testid}>
      <p className="mb-2 text-xs text-slate-500">Durée estimée : {data?.duration_minutes} min · Créneaux <span className="text-[#1D9BF0]">disponibles</span> / <span className="text-slate-400">déjà pris</span></p>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {slots.map((s) => {
          const selected = value === s.time;
          return (
            <button
              key={s.time}
              type="button"
              data-testid={`${testid}-${s.time}`}
              disabled={!s.available}
              onClick={() => onChange(s.time)}
              className={`rounded-xl border-2 px-2 py-2 text-sm font-semibold transition-colors ${
                !s.available
                  ? "cursor-not-allowed border-slate-100 bg-slate-100 text-slate-400 line-through"
                  : selected
                  ? "border-[#263871] bg-[#263871] text-white"
                  : "border-[#1D9BF0]/40 bg-[#E0F2FE] text-[#263871] hover:border-[#1D9BF0]"
              }`}
              title={s.available ? `${s.time} – ${s.end}` : "Déjà pris"}
            >
              {s.time}
            </button>
          );
        })}
      </div>
      {slots.length === 0 && <p className="text-sm text-slate-400">Aucun créneau pour cette durée ce jour-là.</p>}
    </div>
  );
}
